import 'sticky-kit/dist/sticky-kit';

ifInternetExplorer();

function ifInternetExplorer() {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf('MSIE ');

	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		if ($('.js-sticky').length > 0) {
			$('.js-sticky').stick_in_parent({
				offset_top: 80
			});
		}
	} else {
		return false;
	}
}
